import { AppCard, AppUseIcon } from 'components/ui';
import { Can, Cannot } from 'components/Can';

import { AppButton } from 'components/form';
import { AppPermissions } from 'utilities/Constants';
import { Trans } from 'react-i18next';
import { orgAdminData } from 'types/ProfileTypes';
import { t } from 'utilities/TranslationUtils';
import { useHistory } from 'react-router-dom';

export const UserManagementSection = ({ organizationAdmins }: { organizationAdmins: orgAdminData[] }) => {
  const history = useHistory();

  return (
    <AppCard title={t('common.userManagement')} className='overflow-hidden'>
      <div>
        <Trans i18nKey='homePage.UserManagementText'>
          Administrators can invite users to join your organization and grant them access to use the TrackMan American Football Practice
          App.
        </Trans>
        <Can need={AppPermissions.ManageUsers}>
          <div className='mt-3'>
            <AppButton variant={'outline-primary'} onClick={() => history.push('/users')}>
              {t('common.userManagement')}
              <AppUseIcon name='ChevronRight' className='ml-2' color='currentColor' style={{ width: '15px' }} />
            </AppButton>
          </div>
        </Can>
        <Cannot need={AppPermissions.ManageUsers}>
          <div className='mt-3'>
            {organizationAdmins && organizationAdmins.length === 1
              ? t('homePage.TrackmanAdmin', {
                  adminName: organizationAdmins[0].name,
                  adminEmail: organizationAdmins[0].email,
                })
              : ''}
            {organizationAdmins && organizationAdmins.length > 1 ? (
              <span>
                {t('homePage.TrackmanAdmins')}
                <ul>
                  {organizationAdmins.map((pa, index) => (
                    <li key={index}>
                      {' '}
                      {pa.name} &lt;{pa.email}&gt;
                    </li>
                  ))}
                </ul>
              </span>
            ) : (
              ''
            )}
          </div>
        </Cannot>
      </div>
    </AppCard>
  );
};

export default UserManagementSection;
